import React from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';
import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';

import Field from '@common/components/validation/field.validation';

import sessionUtil from '@common/helpers/sessionStorage.utils';
import { Overlay, OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';
import { Select, Tag, Spin } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import produce from 'immer';

const NotFound = () => (
  <div style={{ textAlign: 'center' }}>
    <p style={{ color: 'black' }}>Nenhum registro encontrado...</p>
  </div>
);

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      isLoading: false,
      isOpen: false,
      showTooltipTag: false,
      showTooltipSelect: false,
      dataList: [],
      tags: [],
      state: {},
    };
    this.refSelect = React.createRef();
    this.isExterno = sessionUtil.getItem('isExterno');
  }

  static getDerivedStateFromProps(props, currentState) {
    const { name, state, stateName, mapTag } = props;

    if (state) {
      if (JSON.stringify(state) != JSON.stringify(currentState.state)) {
        let tags = state[stateName || name];
        if (tags) tags = tags.map(mapTag);

        const result = produce(state, (draft) => {
          draft[stateName || name] = tags;
        });

        return {
          tags: tags || [],
          state: result,
        };
      }
    }
    return null;
  }

  async handleSearch(value) {
    await this.setState({
      isLoading: true,
    });

    clearTimeout(this.timeout);
    const { mapTag } = this.props;
    this.timeout = setTimeout(async () => {
      if (value && value.toString().trim() != '') {
        const { service, parameters } = this.props;
        const response = await service(value, parameters);
        const dataList = response.data;
        this.setState({
          isLoading: false,
          dataList: dataList.map(mapTag),
          isOpen: !dataList || (dataList && dataList.length == 0) ? true : false,
        });
      } else this.setState({ isLoading: false, dataList: [], isOpen: false });
      this.timeout = undefined;
    }, 500);
  }

  handleChange(data, options, onChange) {
    const { tags } = this.state;

    if (tags.length > data.length) {
      tags.forEach(function (elementTag) {
        let index = data.findIndex((elementArray) => {
          return elementArray.value == elementTag.value;
        });
        if (data[index]) data[index] = { ...data[index], ...elementTag };
      });
    } else {
      data.forEach(function (elementArray, i) {
        let index = tags.findIndex((elementTag) => {
          return elementArray.value == elementTag.value;
        });
        if (index < 0) {
          let result = options.find((item) => {
            return item.value == elementArray.value;
          });
          data[i] = { ...data[i], ...result };
        } else {
          data[i] = { ...data[i], ...tags[index] };
        }
      });
    }

    this.setState({
      tags: data,
      isOpen: false,
      isLoading: false,
    });

    onChange && onChange(data.length > 0 ? data : undefined);
  }

  renderComponent() {
    const { props } = this;
    const { Label, Tooltip, Obrigatorio, Desabilitado, Placeholder, name, PlacementTooltip } = props;
    const { isLoading, isOpen, showTooltipTag, showTooltipSelect, dataList, tags, state } = this.state;

    return (
      <>
        <Overlay
          show={showTooltipTag === false && showTooltipSelect === true ? true : false}
          key={`top-${name}`}
          placement={PlacementTooltip || 'top'}
          target={this.refSelect.current}
        >
          {(props) => {
            return (
              <TooltipBootstrap id={`tooltip-${name}`} {...props}>
                <div className={'fontTooltip'}>{Tooltip || Label}</div>
              </TooltipBootstrap>
            );
          }}
        </Overlay>
        <Field {...props} state={state}>
          {({ value, hasError, onChangeAsync }) => {
            return (
              <LabeledInput {...props}>
                <Select
                  value={value || undefined}
                  mode="multiple"
                  labelInValue={true}
                  filterOption={() => true}
                  autoClearSearchValue={false}
                  name={name}
                  placeholder={Placeholder || Label}
                  required={Obrigatorio}
                  disabled={Desabilitado}
                  options={dataList}
                  style={{ width: '100%', borderRadius: '4px' }}
                  className={`${hasError ? 'form-invalid' : ''}`}
                  notFoundContent={isLoading ? <Spin size="small" /> : isOpen ? <NotFound /> : null}
                  onSearch={this.handleSearch}
                  onChange={(data, options) => this.handleChange(data, options, onChangeAsync)}
                  onBlur={() => {
                    this.setState({
                      dataList: [],
                      isOpen: false,
                      isLoading: false,
                    });
                  }}
                  onMouseOver={() => {
                    const { showTooltipTag } = this.state;
                    if (!showTooltipTag) this.setState({ showTooltipSelect: true });
                  }}
                  onMouseLeave={() => {
                    this.setState({
                      showTooltipSelect: false,
                      showTooltipTag: false,
                    });
                  }}
                  showArrow={true}
                  tagRender={(props) => {
                    let result = tags.find((item) => item.value == props.value);

                    if (result) {
                      return (
                        <OverlayTrigger
                          key={`top-${result.label}`}
                          placement={PlacementTooltip || 'top'}
                          overlay={
                            <TooltipBootstrap id={`tooltip-${result.label}`}>
                              <div className={'fontTooltip'}>{result.tooltip}</div>
                            </TooltipBootstrap>
                          }
                        >
                          <Tag
                            ref={(e) => {
                              if (e) {
                                e.onmouseover = () => {
                                  this.setState({ showTooltipTag: true });
                                };
                              }
                            }}
                            onMouseLeave={() => {
                              this.setState({ showTooltipTag: false });
                            }}
                            style={{
                              textAlign: 'center',
                              marginTop: !this.isExterno ? '1px' : null,
                            }}
                            icon={
                              <CloseOutlined
                                className="float-right"
                                style={{
                                  display: 'inline-block',
                                  verticalAlign: 'middle',
                                  lineHeight: 'normal',
                                  marginLeft: '5px',
                                  marginTop: this.isExterno ? '1.5px' : null,
                                }}
                                onClick={props.onClose}
                              />
                            }
                          >
                            {result.selectedItem || props.label || props.value}
                          </Tag>
                        </OverlayTrigger>
                      );
                    } else return null;
                  }}
                ></Select>
              </LabeledInput>
            );
          }}
        </Field>
      </>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className="form-control" readOnly>
                  {field.value || ''}
                </label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>{field.value || ''}</label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
